module.exports = __webpack_public_path__ + "img/wish.94dc6b0d.png";